// ============== Секція типів авто ======================
import {
  CARS_PRICE_BOARDING,
  CARS_PRICE_KM,
} from '../../../../ALL_PRICES/PRICES.js';
import { loadLs, saveLs } from '../../../storage/localStorage';
import { setSelectedCarsOrderData } from '../orderData';
import { tripData } from '../step1/trip-form.js';
import { currentCurrency } from './currentCurrency.js';
import { renderPriceInfo } from './utils/renderPriceInfo.js';
// =====================================
// Дані по авто
// =====================================
const CARS_DATA = {
  'premium-minivan': {
    title: 'Premium Minivan',
    price_km: CARS_PRICE_KM['premium-minivan'],
    price_boarding: CARS_PRICE_BOARDING['premium-minivan'],
    capacity: 6,
    luggage: 4,
  },
  minivan: {
    title: 'Minivan',
    price_km: CARS_PRICE_KM.minivan,
    price_boarding: CARS_PRICE_BOARDING.minivan,
    capacity: 7,
    luggage: 7,
  },
  premium: {
    title: 'Premium',
    price_km: CARS_PRICE_KM.premium,
    price_boarding: CARS_PRICE_BOARDING.premium,
    capacity: 3,
    luggage: 2,
  },
  comfort: {
    title: 'Comfort',
    price_km: CARS_PRICE_KM.comfort,
    price_boarding: CARS_PRICE_BOARDING.comfort,
    capacity: 4,
    luggage: 2,
  },
  standart: {
    title: 'Standart',
    price_km: CARS_PRICE_KM.standart,
    price_boarding: CARS_PRICE_BOARDING.standart,
    capacity: 4,
    luggage: 2,
  },
};

// =====================================
// Селектори
// =====================================
const refs = {
  list: document.querySelector('.cars__cars-list'),
  counters: document.querySelectorAll('[data-counter]'),
  carList: document.querySelector('.cars__list'),
};
const { list, counters, carList } = refs;

// =====================================
// Початковий об'єкт для selectedCars
// =====================================
const initialSelectedCars = {
  'premium-minivan': {
    title: CARS_DATA['premium-minivan'].title,
    count: 0,
    pricing: {
      price_km: CARS_DATA['premium-minivan'].price_km,
      price_boarding: CARS_DATA['premium-minivan'].price_boarding,
      price_one: 0,
      price_total: 0,
    },
    capacity: CARS_DATA['premium-minivan'].capacity,
    luggage: CARS_DATA['premium-minivan'].luggage,
  },
  minivan: {
    title: CARS_DATA.minivan.title,
    count: 0,
    pricing: {
      price_km: CARS_DATA.minivan.price_km,
      price_boarding: CARS_DATA.minivan.price_boarding,
      price_one: 0,
      price_total: 0,
    },
    capacity: CARS_DATA.minivan.capacity,
    luggage: CARS_DATA.minivan.luggage,
  },
  premium: {
    title: CARS_DATA.premium.title,
    count: 0,
    pricing: {
      price_km: CARS_DATA.premium.price_km,
      price_boarding: CARS_DATA.premium.price_boarding,
      price_one: 0,
      price_total: 0,
    },
    capacity: CARS_DATA.premium.capacity,
    luggage: CARS_DATA.premium.luggage,
  },
  comfort: {
    title: CARS_DATA.comfort.title,
    count: 0,
    pricing: {
      price_km: CARS_DATA.comfort.price_km,
      price_boarding: CARS_DATA.comfort.price_boarding,
      price_one: 0,
      price_total: 0,
    },
    capacity: CARS_DATA.comfort.capacity,
    luggage: CARS_DATA.comfort.luggage,
  },
  standart: {
    title: CARS_DATA.standart.title,
    count: 0,
    pricing: {
      price_km: CARS_DATA.standart.price_km,
      price_boarding: CARS_DATA.standart.price_boarding,
      price_one: 0,
      price_total: 0,
    },
    capacity: CARS_DATA.standart.capacity,
    luggage: CARS_DATA.standart.luggage,
  },
};

// =====================================
// Ініціалізація об'єкта для збереження вибраних авто
// =====================================

export let selectedCars = initialSelectedCars;

export const resetSelectedCars = () => {
  Object.entries(selectedCars).forEach(([carType]) => {
    setSelectedCars(carType, 0);
  });
  saveLs(KEY_LS, {});
  setSelectedCarsOrderData({});
};

const KEY_LS = 'selected-cars-data';

// =====================================
// Функція для оновлення selectedCars
// =====================================
export const setSelectedCars = (carType, count, setLS = true) => {
  const price_one = calculatePriceForOneCar(carType);
  // Оновлення selectedCars
  if (!selectedCars[carType]) return;
  Object.assign(selectedCars, {
    [carType]: {
      ...selectedCars[carType],
      count,
      pricing: {
        ...selectedCars[carType].pricing,
        price_one: price_one,
        price_total: price_one * (count || 0),
      },
    },
  });

  // Зберігаємо лише кількість в localStorage
  if (setLS) {
    saveLs(
      KEY_LS,
      Object.fromEntries(
        Object.entries(selectedCars).map(([key, { count }]) => [key, count])
      )
    );
  }
  // Оновлення лише вибраних автомобілів (count > 0) в orderData
  setSelectedCarsOrderData(
    Object.fromEntries(
      Object.entries(selectedCars).filter(([, { count }]) => count > 0)
    )
  );

  renderPriceInfo();

  // Оновлення лічильників на UI
  counters.forEach(el => {
    if (el.dataset.counter === carType) {
      el.textContent = count >= 0 ? count : 0;
      if (!el.classList.contains('cars__counter-value')) {
        if (count > 0) {
          el.parentNode.classList.remove('visually-hidden');
        } else {
          el.parentNode.classList.add('visually-hidden');
        }
      }
    }
  });

  // Додаємо клас вибраного авто
  const card = carList?.querySelector(`.cars__card[data-car="${carType}"]`);
  if (card) {
    if (count > 0) {
      card.classList.add('selected-car');
    } else {
      card.classList.remove('selected-car');
    }
  }
};

// =====================================
// Відновлення даних з localStorage
// =====================================
const selectedCarsLS = loadLs(KEY_LS);
if (selectedCarsLS) {
  Object.entries(selectedCarsLS).forEach(([carType, count]) => {
    if (selectedCars[carType]) {
      selectedCars[carType].count = count;
    }
  });
}

// =====================================
// Слухач кліків на картках авто
// =====================================
carList?.addEventListener('click', event => {
  // Зупиняємо клік class="cars__card-counter"
  const counter = event.target.closest('.cars__card-counter');
  if (counter) return;

  // Ігноруємо кліки не по картках авто
  const card = event.target.closest('.cars__card');
  if (!card || !carList.contains(card)) return;

  const carType = card.dataset.car;
  if (!carType || !CARS_DATA[carType]) return;

  // Оновлюємо selectedCars
  const currentCount = selectedCars[carType]?.count || 0;
  if (currentCount === 0) {
    setSelectedCars(carType, 1);
  } else {
    setSelectedCars(carType, 0);
  }
});

// =====================================
// Слухач кліків на кнопках лічильників
// =====================================
const handleClickCounter = event => {
  const button = event.target.closest('.btn');
  if (!button) return;

  const isPlus = button.classList.contains('btn-plus');
  const isMinus = button.classList.contains('btn-minus');
  if (!isPlus && !isMinus) return;

  const counterEl = button.parentElement.querySelector('span[data-counter]');
  const carType = counterEl.dataset.counter;

  let newCount = 0;

  // Оновлення лічильника
  if (isPlus) {
    newCount = (selectedCars[carType]?.count || 0) + 1;
  }
  if (isMinus) {
    newCount = (selectedCars[carType]?.count || 0) - 1;
  }
  setSelectedCars(carType, newCount < 0 ? 0 : newCount);
};
if (list) list.addEventListener('click', handleClickCounter);
if (carList) carList.addEventListener('click', handleClickCounter);

// =====================================
// Функція для розрахунку ціни за одне авто
// =====================================
function calculatePriceForOneCar(carType) {
  if (!tripData?.distance || !tripData?.distance?.value) return 0;

  const price_km = CARS_DATA[carType]?.price_km || 0; // Ціна за км для цього типу авто
  const distanceKM = parseInt(tripData.distance.value / 1000 || 0); // Конвертуємо метри в кілометри
  const boardingCost = CARS_DATA[carType]?.price_boarding || 0; // Вартість посадки

  // Total price in current currency.
  const totalPrice = price_km * distanceKM + boardingCost;
  const { exchangeRate } = currentCurrency;
  const totalPriceInCurrentCurrency = totalPrice / exchangeRate;
  if (currentCurrency.title === 'CZK') {
    // Розрахунок загальної ціни з округленням до найближчих 50
    return Math.ceil(totalPriceInCurrentCurrency / 50) * 50;
  } else {
    // Розрахунок загальної ціни з округленням до найближчих
    return Math.ceil(totalPriceInCurrentCurrency / 1) * 1;
  }
}

// =====================================
// Функція для оновлення загальної ціни на UI
// =====================================
export const renderPrice = () => {
  if (!carList) return;
  Array.from(carList.children).forEach(el => {
    const carType = el.dataset.car; // Отримуємо тип авто з data-car
    if (!carType) return;

    const price_one = calculatePriceForOneCar(carType);
    const priceEl = el.querySelector('.cars__price');

    if (priceEl) {
      priceEl.textContent = `${price_one} ${currentCurrency.symbol}`;
    }
  });
  // Оновлюємо ціну в selectedCars
  updatePricingOnTripChange();
};

// =====================================
// Функція для оновлення pricing в selectedCars при зміні tripData
// =====================================
export const updatePricingOnTripChange = () => {
  Object.entries(selectedCars).forEach(([carType, { count }]) => {
    setSelectedCars(carType, count, false); // Оновлення selectedCars без збереження в LS
  });
};
